export default {
  namespaced: true,
  state: {
    integrations: [],
    integrationsSuccess: false,

    googleAds: null,
    googleAdsConnected: false,
    googleAdsAccounts: [],
  },
  mutations: {
    SET_INTEGRATIONS_SUCCESSS(state, data) {
      state.integrationsSuccess = data;
    },
    SET_INTEGRATIONS(state, data) {
      state.integrations = data;
    },

    SET_GOOGLE_ADS(state, data) {
      state.googleAds = data;
    },
    SET_GOOGLE_ADS_CONNECTED(state, data) {
      state.googleAdsConnected = data;
    },
    SET_GOOGLE_ADS_ACCOUNTS(state, data) {
      state.googleAdsAccounts = data;
    },
  },
};
